module.exports = __webpack_public_path__ + "img/mars.1de06462.png";